import { useTranslation } from 'react-i18next';

import { Select } from '@myphx-engineering/phx-design-system';

import type { QuantityOption } from '../../graphql/generated/graphql';

export const MedicationQuantitySelect = ({
    quantityOptions,
    selectedQuantity,
    setSelectedQuantity,
}: {
    quantityOptions: QuantityOption[];
    selectedQuantity: string;
    setSelectedQuantity: (value: string) => void;
}) => {
    const { t } = useTranslation(['myphx']);

    const data = quantityOptions.map((option) => ({
        value: option.value,
        label: option.displayText,
    }));

    const onChange = (value: string | null) => {
        if (value) setSelectedQuantity(value);
    };

    return (
        <Select
            label={t('drugConfig.quantity')}
            disabled={quantityOptions.length <= 1}
            value={selectedQuantity}
            onChange={onChange}
            data={data}
        />
    );
};
